<template>
  <div class="animated fadeIn vld-parent custom-100">
    <b-row>
      <b-col sm="12">
        <searchBar ref="searchBar" :user-groups="userGroups"
                   :user-group-select="userGroupSelect"
                   :selected-date="currentDate"
                   :on-search="queryData"></searchBar>
      </b-col>
    </b-row>
    <b-row class="custom-flex-1">
      <b-col sm="12">
        <auftraegeTable ref="auftraegeTable" :all-groups="allGroups" :table-data="data" :show-freigabe="settings.fg_stufe1"></auftraegeTable>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import searchBar from '../aufgaben_verwaltung/AufgabenVerwaltungSearchBar.vue'
import auftraegeTable from '../aufgaben/aufgaben_table_internal.vue'
import {Redirect_500, Redirect_Login, Server_URL} from "@/shared/utils";
import {decryptAES} from "@/shared/crypto";
import {DateTime as LuxonDateTime} from "luxon";
import {parseTimestamp} from "@/shared/dates";


export default {
  name: "AufgabenverwaltungInternal",
  components: {'searchBar':searchBar, 'auftraegeTable': auftraegeTable},
  data() {
    return {
      // SearchbarProps
      userGroups: [],
      userGroupSelect: undefined,
      data: [],
      currentPage: 1,
      settings: {fg_stufe1: false},
      allGroups: [],
      currentDate: null,
    }
  },
  props:{
    showLoader: {
      type: Function,
      default: undefined
    },
    hideLoader: {
      type: Function,
      default: undefined
    },
  },
  methods: {
    responseOkGet(response) {
      if (response.status === 200 && response.body.status === "ok") {
        this.currentDate = LuxonDateTime.local().toISO();
        let groups = response.body.data.groups;
        let module_groups = response.body.data.module_groups;
        let augr = response.body.data.augrs;
        this.userGroups.push({text: "Alle", value: {id: "all", module: "all"}});
        this.userGroupSelect = {id: "all", module: "all"};
        for (let i = 0; i < module_groups.length; i++) {
          let res = JSON.parse(sessionStorage.getItem(module_groups[i].name));
          if (res !== null) {
            this.userGroups.push({text: res.full_name, value: module_groups[i]});
            this.userGroupSelect = module_groups[i];
          } else {
            switch (module_groups[i].module) {
              case "ab":
                this.userGroups.push({text: module_groups[i].name, value: module_groups[i]});
                break;
            }
          }
        }
        this.allGroups = response.body.data.all_groups;
        this.settings = response.body.data.global_settings;
        this.queryData(this.userGroupSelect, "O", "A", LuxonDateTime.local().toISO(), "Y", "");
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkFetch(response) {
      this.hideLoader();
      this.$refs.auftraegeTable.currentPage = 1;
      this.$refs.searchBar.onFirstSearch();

      if (response.status === 200 && response.body.status === "ok") {
        this.data = response.body.data;
        this.decryptData();
      } else {
        window.location = Redirect_500;
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    queryData(group, status, planning, currentDate, dateType, searchText) {
      group = group.id;
      this.showLoader();
      let d = parseTimestamp(new Date(Date.parse(currentDate)), "DD.MM.YYYY")
      d = encodeURIComponent(d)
      this.$http.get(
          Server_URL+'/auftragsbuch/data/av/fetch/'+group+
          "?status_type="+status+
          "&planning_state="+planning+
          "&search_text="+searchText+
          "&selected_date_type="+dateType+
          "&selected_start_date="+d
      ).then(this.responseOkFetch, this.responseError)
    },
    async decryptData() {
      for (let i = 0; i < this.data.length; i++) {
        try {
          if (this.data[i].gi_memo !== null && this.data[i].gi_memo !== "") {
            this.data[i].gi_memo = await decryptAES(sessionStorage.getItem("aes"), this.data[i].gi_memo);
          }
        } catch (e) {
          //console.log(e)
        }
      }
    },
  },
}
</script>

<style scoped>

</style>
